import { Component, HostListener } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-forget',
  templateUrl: './forget.component.html',
  styleUrls: ['./forget.component.scss']
})
export class ForgetComponent {
  submitted = false;
  isLoading:boolean = false;
  buttonTitle = "Submit"
  successMessage: string = '';
  errorMessage: string = '';
  form: FormGroup = new FormGroup({
    username: new FormControl(''),
  });
  url:any
  constructor(private toast:ToastrService, private coreAuth:AuthService, private router:Router, private formBuilder: FormBuilder)
  {
    this.url = window.location.href.replace("forget-password","")

  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.onSubmit(); // Directly call onSubmit() for this form
    }
  }


  ngOnInit(): void {
    this.form = this.formBuilder.group(
      {
        username: ['',[Validators.required]]
      }
    );
  }
  get formError(): any {
    return this.form.controls;
  }
  onSubmit()
  {
    this.successMessage = '';
    this.errorMessage = '';
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
   this.isLoading = true;
   this.buttonTitle = "Loading"
   let param = {...this.form.value,...{resetUrl: this.url+"reset-password"}}
   this.coreAuth.forgetPassword(param).subscribe({
    next: (res) => {

      this.buttonTitle = "Resend"
      this.isLoading = false;
      this.toast.success(res,'Reset Password Link Sent ');
      this.successMessage = res;
      this.form.reset();
    },
    error: (e) => {
      this.buttonTitle = "Resend"
      this.toast.error(e.error?.message,'Username is not found');

      this.isLoading = false;
    },
    complete: () => {
      this.buttonTitle = "Resend"
      this.isLoading = false;
    }
})

  }
  login()
  {
    this.router.navigate(['login']);
  }
}
